"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { SynopsisData } from "./SynopsisData";
import { useEffect, useState } from "react";
import useSynopsisQuery from "@/reactQuery/synopsis";
import RepsDetailIcon from "@/Components/website/common/Icons/synopsis/RepsDetailIcon";
// import RepsImage from "@/app/(public)/products/[type]/[productID]/RepsImage";
import Image from "next/image";
import TypingText from "../Common/TypingText";
import Avatar from "react-avatar";
import { sanitizeImageUrl } from "@/utils/imageUrl";
import RepsListing from "@/app/(public)/products/[type]/[productID]/RepsListing";
import { GoHeartFill, GoHeart } from "react-icons/go";
import AiIcon from "@/Components/website/common/Icons/synopsis/AiIcon";
import loaderGif from "../../../public/Images/synopsis/alpha-spinner.gif";
const hasMeaningfulSynopsisValue = value => {
  if (Array.isArray(value)) return value.some(hasMeaningfulSynopsisValue);
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  return Boolean(normalized && normalized !== "n/a" && normalized !== "not available");
};
const isEmptySynopsis = synopsis => {
  if (!synopsis) return true;
  return [synopsis.indication, synopsis.mechanism, synopsis.efficacy, synopsis.safety, synopsis.dosing, synopsis.patient].every(value => !hasMeaningfulSynopsisValue(value));
};
const needsPipelineSynopsisRefresh = product => {
  if ((product?.type || '').toLowerCase() !== 'pipeline') return false;
  if (Number(product?.synopsis?._pipelineSynopsisVersion || 0) < 2) return true;
  return [product?.synopsis?.mechanism, product?.synopsis?.safety, product?.synopsis?.dosing, product?.synopsis?.patient].some(value => !hasMeaningfulSynopsisValue(value));
};
const Synopsis = t0 => {
  const $ = _c(37);
  const {
    product,
    reviews
  } = t0;
  const {
    setProductId,
    setproductType,
    streamingSynopsis
  } = useSynopsisQuery();
  const [synopsisData, setSynopsisData] = React.useState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [repsData, setRepsData] = React.useState(t1);
  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);
  const [isAnySkeletonLoading, setIsAnySkeletonLoading] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["Generating with AlphaAI...", "Creating synopsis...", "Summarizing key clinical information..."];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const loadingMessages = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setLoadingMessageIndex(Math.floor(Math.random() * loadingMessages.length));
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  React.useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== streamingSynopsis) {
    t5 = () => {
      if (streamingSynopsis) {
        setSynopsisData(streamingSynopsis);
      }
    };
    t6 = JSON.stringify(streamingSynopsis);
    $[4] = streamingSynopsis;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = [t6];
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  useEffect(t5, t7);
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const interval = setInterval(() => {
        setLoadingMessageIndex(prevIndex => (prevIndex + 1) % loadingMessages.length);
      }, 3500);
      return () => clearInterval(interval);
    };
    t9 = [loadingMessages.length];
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  useEffect(t8, t9);
  let t10;
  if ($[11] !== product || $[12] !== setProductId || $[13] !== setproductType) {
    t10 = () => {
      if (product && product.productAlias) {
        const reps = product.reps.length > 3 ? product.reps.slice(0, 2) : product.reps;
        setRepsData(reps);
        if (product.synopsis && !isEmptySynopsis(product.synopsis) && !needsPipelineSynopsisRefresh(product)) {
          setSynopsisData(product.synopsis);
        } else {
          setSynopsisData(undefined);
          setProductId(product.productAlias);
          setproductType(product.type);
        }
      }
    };
    $[11] = product;
    $[12] = setProductId;
    $[13] = setproductType;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== product) {
    t11 = [product];
    $[15] = product;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  useEffect(t10, t11);
  const isSourcePending = synopsisData?._sourceStatus === "pending";
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["trial-protocol", "trial-results"];
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const isClinicalTrialSource = t12.includes(synopsisData?._sourceStatus);
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="my-auto text-sm sm:text-base font-semibold text-black">Synopsis</div>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== isAnySkeletonLoading || $[20] !== isClinicalTrialSource || $[21] !== isSourcePending || $[22] !== loadingMessageIndex) {
    t14 = <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 sm:gap-3 max-w-full">{t13}{isSourcePending ? <div className="flex items-center px-2 sm:px-3 py-1 text-[10px] sm:text-xs font-medium border border-amber-200 bg-amber-50 rounded-[100px] text-amber-700"><div className="whitespace-nowrap">Official data pending</div></div> : isClinicalTrialSource ? <div className="flex gap-1.5 sm:gap-2 items-center px-2 sm:px-3 py-1 text-[10px] sm:text-xs font-medium border border-solid border-stone-300 rounded-[100px] text-neutral-600"><div className="object-contain shrink-0 w-5 sm:w-6 aspect-square"><AiIcon /></div><div className="whitespace-nowrap">Compiled from ClinicalTrials.gov</div></div> : isAnySkeletonLoading ? <div className="flex gap-1.5 sm:gap-2 items-center px-2 sm:px-3 py-1 text-[10px] sm:text-xs font-medium border border-solid border-stone-300 rounded-[100px] text-neutral-600"><div className="object-contain shrink-0 w-5 sm:w-6 aspect-square"><Image src={loaderGif} alt="loader" width={20} height={20} /></div><div className="whitespace-nowrap"><TypingText text={loadingMessages[loadingMessageIndex]} typingSpeed={40} /></div></div> : <div className="flex gap-1.5 sm:gap-2 items-center px-2 sm:px-3 py-1 text-[10px] sm:text-xs font-medium border border-solid border-stone-300 rounded-[100px] text-neutral-600"><div className="object-contain shrink-0 w-5 sm:w-6 aspect-square"><AiIcon /></div><div className="whitespace-nowrap">Generated with AlphaAI</div></div>}</div>;
    $[19] = isAnySkeletonLoading;
    $[20] = isClinicalTrialSource;
    $[21] = isSourcePending;
    $[22] = loadingMessageIndex;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== isSourcePending || $[25] !== product?.openfda || $[26] !== reviews || $[27] !== synopsisData) {
    t15 = isSourcePending ? <div className="mt-5 rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-5"><div className="text-sm font-semibold text-neutral-700">Clinical information is not available yet</div><div className="mt-1 text-xs sm:text-sm leading-6 text-neutral-500">Clinical label information has not been verified for this product yet. The synopsis will become available when verified information is added.</div></div> : <SynopsisData synopsisData={{
      product: product?.openfda.brand_name,
      ...synopsisData
    }} reviews={reviews} onSkeletonLoad={isLoading => setIsAnySkeletonLoading(isLoading)} />;
    $[24] = isSourcePending;
    $[25] = product?.openfda;
    $[26] = reviews;
    $[27] = synopsisData;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== product || $[30] !== repsData) {
    t16 = repsData.length > 0 && <><div className="flex gap-2 items-center mt-3 sm:mt-4 text-xs sm:text-sm font-medium text-black"><div className="object-contain shrink-0 w-5 sm:w-6 aspect-square"><RepsDetailIcon /></div><div>Reps in your area:</div></div><div className="mt-2 sm:mt-2.5 w-full"><RepsListing hideBorderAndHeading={true} reps={repsData} product={{
          ...product,
          id: product?._id
        }} isLoggedIn={product?.isLoggedIn} address={product?.address} /></div></>;
    $[29] = product;
    $[30] = repsData;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="mt-4 sm:mt-7 text-[10px] sm:text-sm font-medium text-neutral-400">Disclaimer: The synopsis and product information provided on Alpha.MD are derived from openFDA data and are for informational purposes only. This information may not be comprehensive, accurate, or up-to-date. Clinicians should exercise their own professional judgment in interpreting and using this information, and consult the official prescribing information for the most accurate and current details.</div>;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t14 || $[34] !== t15 || $[35] !== t16) {
    t18 = <div className="flex flex-col self-center w-full"><div className="w-full"><div className="flex flex-col"><div className="flex flex-col w-full"><div className="flex z-10 flex-col"><div className="flex overflow-hidden flex-col px-3 sm:px-6 pt-4 sm:pt-5 pb-6 sm:pb-9 w-full bg-white rounded-lg">{t14}{t15}{t16}{t17}</div></div></div></div></div></div>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
};
export default Synopsis;